import {useCan} from '@/shared/hooks/use-permissions'
import {drawer} from '@cypro/ui/components'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {useConfirmDeleteTradeName} from '@/modules/products/trade-names/api'
import {TradeNameDrawerTabsList} from '@/modules/products/trade-names/components/trade-name-drawer/tabs-list'
import {AboutTab} from '@/modules/products/trade-names/components/trade-name-drawer/tabs/about'
import {HistoryTab} from '@/modules/products/trade-names/components/trade-name-drawer/tabs/activity'
import {BatchesTab} from '@/modules/products/trade-names/components/trade-name-drawer/tabs/batches'
import {TradeNameSummary} from '@/modules/products/trade-names/components/trade-name-drawer/trade-name-summary'
import {getTradeNameDrawerId} from '@/modules/products/trade-names/components/trade-name-drawer/util'
import {DeleteResourceButton} from '@cypro/ui/components/ui/delete-resource-button'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useTradeNameContext} from '@/shared/contexts/trade-name'
import {toaster} from '@cypro/ui/toaster'
import {Drawer, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function TradeNameDrawer() {
  const canManageCatalogue = useCan('catalogue.manage')
  const {t} = useTranslate('common')
  const {tradeName} = useTradeNameContext()
  const deleteTradeName = useConfirmDeleteTradeName()

  async function onDelete() {
    try {
      await deleteTradeName({id: tradeName.id})
      const drawerId = getTradeNameDrawerId(tradeName.id)
      drawer.close(drawerId)
      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
    } catch {}
  }

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{t('trade_name_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <TradeNameSummary />

        <Tabs.Root defaultValue="about" spaceY="5" lazyMount>
          <TradeNameDrawerTabsList />

          <AboutTab />
          <BatchesTab />
          <HistoryTab />
        </Tabs.Root>
      </DrawerBody>

      {canManageCatalogue && (
        <DrawerFooter display="flex" justifyContent="space-between">
          <DeleteResourceButton onClick={onDelete} />

          <LinkButton
            to="/configuration/products/trade-names/new"
            search={{tradeNameId: tradeName.id}}
            colorPalette="cyan"
            data-e2e="edit-trade-name"
          >
            {t('edit')}
          </LinkButton>
        </DrawerFooter>
      )}
    </>
  )
}
